export var isActionable = function (_a) {
    var isOwner = _a.isOwner, isAuthor = _a.isAuthor, isReportable = _a.isReportable, isSpam = _a.isSpam;
    return (isOwner || isAuthor || isReportable) && !isSpam;
};
export function canPeek(comment) {
    // $canPeek = ($is_admin_mode && ($is_hidden || $is_admin_hidden || $is_spam || $is_deleted)) // admin can see all
    //         || ($is_owner && (($is_hidden && !$is_admin_hidden) || $is_spam)) // owner can see owner-hidden or spam
    //         || ($is_author && $is_deleted); // author can see deleted
    if (comment.isOwner) {
        // owner can see owner-hidden
        if (comment.isHidden && !comment.isAdminHidden) {
            return true;
        }
        // and spam
        if (comment.isSpam) {
            return true;
        }
    }
    if (comment.isAuthor) {
        // comment author can see deleted
        if (comment.isDeleted) {
            return true;
        }
    }
    return false;
}
export function isCommentHidden(_a, isPeeking) {
    var isDeleted = _a.isDeleted, isHidden = _a.isHidden, isAdminHidden = _a.isAdminHidden, isSpam = _a.isSpam, replies = _a.replies;
    // these rules match those in CommentBody
    var isVisible = !isAdminHidden && !isDeleted;
    if (!isPeeking && isSpam && replies !== 0) {
        return true;
    }
    if (!isPeeking && (isHidden || !isVisible) && replies !== 0) {
        return true;
    }
    if ((isHidden || !isVisible || isSpam) && !isPeeking) {
        return true;
    }
    return false;
}
export function getCommentNotificationQueue(_a) {
    var commentId = _a.commentId;
    return "comment-".concat(commentId);
}
export function generateReplyEditorId(comment) {
    return "reply-".concat(comment.commentId);
}
//# sourceMappingURL=utils.js.map